import styled from "styled-components";

export const PoputBox = styled.div`

display: none;

position: fixed;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);



background-color: red;
width: 500px;
height: 250px;

border-radius: 10px;
border: 1px solid red;
`